import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal';
import ItemPicker from 'components/ItemPicker';
import { useFetchDomains } from 'actions/domains';
import { jsx as _jsx } from "react/jsx-runtime";
function renderDomainAsSubtitle(item) {
  return item.subdomain;
}
export default function DomainPickerModal(_ref) {
  var onSubmit = _ref.onSubmit,
    onClose = _ref.onClose,
    defaultSelectedItems = _ref.defaultSelectedItems,
    defaultIndeterminateItems = _ref.defaultIndeterminateItems,
    title = _ref.title,
    _ref$filter = _ref.filter,
    filter = _ref$filter === void 0 ? {} : _ref$filter;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var _useFetchDomains = useFetchDomains(_objectSpread(_objectSpread({}, filter), searchValue && {
      name: "%".concat(searchValue, "%")
    })),
    items = _useFetchDomains.items,
    hasNextPage = _useFetchDomains.hasNextPage,
    fetchNextPage = _useFetchDomains.fetchNextPage,
    isError = _useFetchDomains.isError,
    isLoading = _useFetchDomains.isLoading,
    isFetchingNextPage = _useFetchDomains.isFetchingNextPage;
  var modalTitle = title || t('actions_distribute_playlist');
  var labels = {
    getSelectionStatus: function getSelectionStatus(count) {
      return t('domain_selection_status', {
        count: count
      });
    }
  };
  return /*#__PURE__*/_jsx(Modal, {
    id: "domain-picker-modal",
    "aria-label": modalTitle,
    onRequestClose: onClose,
    children: /*#__PURE__*/_jsx(ItemPicker, {
      title: modalTitle,
      labels: labels,
      renderItemSubtitle: renderDomainAsSubtitle,
      defaultSelectedItems: defaultSelectedItems,
      defaultIndeterminateItems: defaultIndeterminateItems,
      onSubmit: onSubmit,
      onClose: onClose,
      onSearchValueChange: setSearchValue,
      items: items,
      hasNextPage: hasNextPage,
      onFetchNextPage: fetchNextPage,
      isFetchingNextPage: isFetchingNextPage,
      isError: isError,
      isLoading: isLoading
    })
  });
}